
import { mapActions } from 'vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import VTable from '@/components/table/index.vue';
import Moment from 'moment';
import { directive as VueClickAway } from 'vue-clickaway';

import TableHead from './TableHead';

@Component({
  name: 'InvitesList',

  components: {
    VTable,
    TableHead
  },

  directives: {
    onClickAway: VueClickAway
  },

  methods: {
    ...mapActions('vacancies', ['fetchVacanciesListDropdown'])
  }
})

export default class InvitesList extends Vue {
  @Prop() readonly list: [];
  @Prop({ default: false }) readonly isItSearch: boolean;
  @Prop() readonly filter_temp_selected_vacancy: [];
  @Prop() readonly filter_temp_selected_statuses: [];
  @Prop() readonly filter_temp_dates: [];
  @Prop() readonly filter_temp_selected_creators: [];
  @Prop() readonly filter_temp_selected_tags: [];
  @Prop() readonly temp_name: string;
  @Prop() readonly temp_email: string;
  @Prop() readonly temp_phone: string;
  @Prop() readonly temp_tag: string;
  @Prop({ default: 'none' }) readonly show_filter: string;
  @Prop() readonly filter_loaded: boolean;
  @Prop() readonly filter_creators: [];
  @Prop() readonly filter_tags: [];
  @Prop() readonly filter_statuses: [];
  @Prop() readonly filter_vacancies: [];
  @Prop() readonly pendingSpinner: boolean;

  private tableName = 'invites';
  private isSettingsDropdownVisible = false;

  private headers = [
    {
      id: 'checkbox',
      name: '',
      is_visible: true,
      is_base: true,
      width: '60px'
    },
    {
      id: 'date',
      name: this.$tr('common.list.date'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'vacancy',
      name: this.$tr('common.list.vacancy'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'name',
      name: this.$tr('common.list.name'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'status',
      name: this.$tr('common.list.status'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'source',
      name: this.$tr('common.list.source'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'email',
      name: this.$tr('common.list.email'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'phone',
      name: this.$tr('common.list.phone'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'creator',
      name: this.$tr('common.list.creator'),
      is_visible: true,
      is_base: false,
      width: ''
    },
    {
      id: 'tags',
      name: this.$tr('responses.tags.title'),
      is_visible: true,
      is_base: false,
      width: ''
    }
  ];

  get loading() {
    return this.$store.getters['invites/loading'];
  }

  get filter() {
    return this.$store.getters['invites/filter'];
  }

  get filter_query() {
    return this.$store.getters['invites/filter_query'];
  }

  public fetchInvites() {
    this.$store.dispatch('invites/fetch');
  }

  public setFilters(val) {
    this.$nextTick(() => {
      setTimeout(() => {
        // console.log('setFilters: ', val);
        this.$store.commit('invites/setFilter', val);

        this.fetchInvites();
      }, 0);
    });
  }

  public updateHeaders(headers) {
    this.headers.splice(0, this.headers.length, ...headers);
  }

  public set_temp_name(name) {
    this.$emit('set_temp_name', name);
  }
  public set_temp_phone(phone) {
    this.$emit('set_temp_phone', phone);
  }
  public set_temp_email(email) {
    this.$emit('set_temp_email', email);
  }
  public set_temp_tag(tag) {
    this.$emit('set_temp_tag', tag);
  }
  public set_filter_temp_dates(model) {
    this.$emit('set_filter_temp_dates', model);
  }
  public set_filter_temp_selected_vacancy(val) {
    this.$emit('set_filter_temp_selected_vacancy', val);
  }
  public set_filter_temp_selected_statuses(val) {
    this.$emit('set_filter_temp_selected_statuses', val);
  }
  public set_filter_temp_selected_creators(val) {
    this.$emit('set_filter_temp_selected_creators', val);
  }
  public set_filter_temp_selected_tags(val) {
    this.$emit('set_filter_temp_selected_tags', val);
  }
  public apply_filter(val) {
    this.$emit('apply_filter', val);
  }
  public cancel_filter() {
    this.$emit('cancel_filter');
  }
  public name_clear() {
    this.$emit('name_clear');
  }
  public phone_clear() {
    this.$emit('phone_clear');
  }
  public email_clear() {
    this.$emit('email_clear');
  }
  public status_id_clear() {
    this.$emit('status_id_clear');
  }
  public tag_id_clear() {
    this.$emit('tag_id_clear');
  }
  public date_clear() {
    this.$emit('date_clear');
  }
  public vacancy_id_clear() {
    this.$emit('vacancy_id_clear');
  }
  public creator_clear() {
    this.$emit('creator_clear');
  }
  public set_show_filter(v) {
    this.$emit('set_show_filter', v);
  }
  public toggleSettingsDropdown() {
    this.isSettingsDropdownVisible = !this.isSettingsDropdownVisible;
  }
  public hideSettingsDropdown() {
    this.isSettingsDropdownVisible = false;
  }
  public exportInvites(e, type = 'all') {
    if (e.target.className.indexOf('disabled') !== -1 || this.pendingSpinner) {
      return false;
    }
    let filter = null;
    if (type === 'filtered') {
      filter = this.filter_query;
    }
    if (type === 'last') {
      let today = Moment().format('YYYY-MM-DD');
      let previous_date = Moment(today).subtract(30, 'days').format('YYYY-MM-DD');
      filter = [
        {
          id: 'date_created',
          list: [previous_date, today]
        }
      ];
    }

    this.$emit('handleExportInvites', filter);
  }

  async created() {
    await this.fetchVacanciesListDropdown({ isActive: true });
  }
}
